<template>
  <div class="edit-script-wrapper" v-wechat-title="pageTitle" v-if="dataDone">
    <div class="script-top-control">
      <div class="top-item" @click="delScript" v-if="isEdit"><icon icon-class="delete"></icon>删除处方</div>
      <div class="top-item" @click="clearHerbsShow = true"><icon icon-class="clear"></icon>清空药材</div>
      <div class="top-item" @click="savePrescription"><icon icon-class="save"></icon>保存处方</div>
    </div>
    <div class="herbs-list" ref="herbsList">
      <div class="form-wrapper" v-if="drug_typeEditShow">
        <div class="form-item click" :class="{'error': drugsError}" @click="drugsPickerShow = true">
          <div class="form-type"><span class="required">处方类型（颗粒|饮片）</span></div>
          <div class="form-content">
            <div class="picker-tips" v-if="!drug_type">请选择
              <icon icon-class="arrow" />
            </div>
            <div class="picker-value" v-else>{{this.drug_type | formulationTypeFilter}}</div>
          </div>
          <div class="form-error" v-if="drugsError">
            <van-icon name="fail" />{{drugsErrorMsg}}</div>
        </div>
      </div>
      <div class="script-title-editor">
        <div class="title-type">处方名称</div>
        <div class="title-typer">
          <input type="text" class="script-title-input" v-model="scriptTitle" placeholder="请输入处方名称" maxlength="20" :style="{fontWeight: scriptTitle ? 'bold' : 'normal'}">
        </div>
      </div>
      <div class="list-wrapper">
        <div class="herb-item" v-for="(item, index) in herbList" :key="index">
          <div class="medicine-info">
            <div class="medicine-control" @click="delMedicine(item)"><i class="delete-icon"></i></div>
            <div class="medicine-name" @click="pickSpecial(item, index)">
              <div class="name">{{item.name}}</div>
              <div class="special-method" v-if="item.remark">{{item.remark}}</div>
            </div>
            <div class="dose"><number-input ref="numberInput" class="dose-input" :class="{'zero': item.num == 0}" :min="0" v-model="item.num" :integer="item.unit != 'g'" />{{item.unit}}</div>
          </div>
          <!-- <div class="medicine-control" @click="delMedicine(item)">删除</div> -->
        </div>
      </div>
    </div>
    <div class="script-bottom-control">
      <div class="search-results" v-show="searchResultShow">
        <template v-if="searchDone" v-for="item in searchResult">
          <div class="result-item script" v-if="item.type != 3" @click="pickHerbItem(item)">
            <div class="script-name">{{item.title}}<span>{{item.type == 1 ? '经方' : '模板'}}</span></div>
            <div class="script-herbs">包含{{item.num || 0}}种药材</div>
          </div>
          <div class="result-item herb" @click="pickHerbItem(item)" v-else>{{item.title}}</div>
        </template>

        <div class="empty-result" v-if="searchResult.length == 0 && searchDone">暂无搜索结果</div>
        <div class="searching" v-if="!searchDone"><van-loading type="spinner" size="16px" /></div>
      </div>
      <div class="add-herb-typer" v-show="searchShow">
        <input type="text" class="herb-search-input" v-model="herbKey" v-ios-bug-fixed @blur="searchBlur" @input="searchHerbs($event)" placeholder="请输入处方或药材名称">
      </div>
      <div class="herb-unit-editor" v-show="herbDoseEditShow">
        <div class="editor-wrapper">
          <div class="herb-info"><span>{{pickedHerb.name}}</span>({{pickedHerb.unit}})</div>
          <div class="input-box">
            <number-input ref="herbUnitInput" class="unit-input" @blur="numberBlur" v-ios-bug-fixed :class="{'zero': pickedHerb.num == 0}" :min="0" v-model="pickedHerb.num" :integer="pickedHerb.unit != 'g'" placeholder="请输入药材数量" />
          </div>
          <button class="unit-edit-button" @click="comfirmUnit">确定</button>
        </div>
      </div>
    </div>

    <!-- 清空药材弹窗 -->
    <x-dialog v-if="clearHerbsShow" title="删除药材" @close="clearHerbsShow = false">
      <div class="clear-content">
        <div class="text">是否清空处方内药材？</div>
        <div class="control">
          <button class="cancel" @click="clearHerbsShow = false">取消</button>
          <button class="confirm" @click="clearHerbs">确定</button>
        </div>
      </div>
    </x-dialog>

    <!-- 选择特殊煎服法 -->
    <van-popup v-model="specialListShow" position="bottom" :style="{height: '60%'}">
      <div class="popup-wrapper">
        <div class="popup-header">
          {{specialIndex == null ? '特殊煎服法' : herbList[specialIndex].name}}
          <span class="close-popup" @click="specialListShow = false">取消</span>
        </div>
        <div class="data-wrapper special-list">
          <div class="special-item" :class="{'selected': item == pickedSpecial}" @click="chooseSpecial(item)" v-for="item in specialData">{{item}}</div>
        </div>
      </div>
    </van-popup>
    <x-dialog v-if="customizeSpecialShow" title="自定义" @close="customizeSpecialShow = false">
      <div class="customize-content">
        <div class="customize-text">
          <input type="text" class="customize-input" v-ios-bug-fixed ref="customizeInput" v-model="customizeSpecial">
        </div>
        <div class="customize-control">
          <button class="cancel" @click="customizeSpecialShow = false">取消</button>
          <button class="confirm" @click="saveCustomizeSpecial">保存</button>
        </div>
      </div>
    </x-dialog>
    <!-- 删除处方模板 -->
    <x-dialog v-if="delScriptShow" @close="delScriptShow = false" title="删除处方模板">
      <div class="del-script-box">
        <div class="warning">是否删除此处方模板</div>
        <p>{{scriptTitle}}</p>
        <div class="tips">一旦删除，将无法找回</div>
        <div class="del-control">
          <button class="cancel" @click="delScriptShow = false">再考虑一下</button>
          <button class="confirm" @click="delScriptAction" :disabled="deleteing">确认删除</button>
        </div>
      </div>
    </x-dialog>
    <van-popup v-model="drugsPickerShow" position="bottom">
      <van-picker show-toolbar :columns="drugsData" value-key="label" @cancel="drugsPickerShow = false" @confirm="confirmDrugs" />
    </van-popup>
  </div>
</template>

<style lang="less" scoped>
  .edit-script-wrapper{
    height: 100%;
    position: relative;
    background: #FAFAFA;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .form-wrapper{
      padding-top: 10px;
      margin-top: 0px;
      background: #FFF;
      .upload-avatar-box{
        width: 100%;
        .van-uploader__input-wrapper{
          width: 100%;
        }
      }
      .form-item{
        position: relative;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #FFF;
        height: 30px;
        margin-bottom: 16px;
        transition: all .1s;
        &.vertical{
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          height: auto;
          .form-content{
            position: relative;
            width: 100%;
            margin-top: 16px;
            .form-textarea{
              border: 1px solid #F7F7F7;
              background: #F7F7F7;
              resize: none;
              padding: 12px;
              line-height: 20px;
              font-size: 15px;
              color: @black;
              width: 100%;
              height: 144px;
              &::-webkit-input-placeholder{
                color: #999;
              }
            }
            .textarea-limit{
              position: absolute;
              right: 8px;
              bottom: 8px;
              font-size: 12px;
              color: #999;
            }
          }
        }
        &.avatar{
          height: 80px;
          margin-bottom: 12px;
        }
        &.click{
          cursor: pointer;
          &:active{
            background: #F9F9F9;
          }
        }
        &.error{
          margin-bottom: 28px;
          .form-content .form-text{
            color: @error;
          }
        }
        .form-type{
          font-size: 15px;
          color: @black;
          padding-left: 5px;
          .required{
            position: relative;
            &::after{
              content: '*';
              position: absolute;
              left: 100%;
              top: 0;
              margin-left: 2px;
              font-size: 16px;
              color: @error;
            }
          }
          .tips{
            margin-top: 6px;
            font-size: 12px;
            color: @xile;
          }
        }
        .form-content{
          color: #666;
          font-size: 16px;
          .avatar-box{
            width: 64px;
            height: 64px;
            overflow: hidden;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            img{
              width: 100%;
              // height: 100%;
            }
          }
          .form-text{
            width: 200px;
            border: 0;
            text-align: right;
            font-size: 16px;
            line-height: 40px;
            color: #666;
            background: transparent;
            &::-webkit-input-placeholder{
              color: #999;
            }
          }
          .picker-tips{
            font-size: 16px;
            color: #999;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            svg{
              position: relative;
              top: 2px;
              font-size: 14px;
              margin-left: 4px;
            }
          }
          .picker-value{
            max-width: 240px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .get-code-button{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 84px;
            height: 32px;
            border: 1px solid @xile;
            color: @xile;
            font-weight: bold;
            background: transparent;
            font-size: 12px;
            border-radius: 4px;
            transition: all .1s;
            &:disabled{
              border-color: #CCC;
              color: #CCC;
              &:active{
                opacity: 1;
              }
            }
            &:active{
              opacity: .8;
            }
          }
        }
        .code-input-box{
          .code-input{
            width: 200px;
            border: 0;
            font-size: 16px;
            line-height: 40px;
            color: #666;
            background: transparent;
            &::-webkit-input-placeholder{
              color: #999;
            }
          }
        }
        .form-error{
          position: absolute;
          right: 16px;
          top: 100%;
          font-size: 12px;
          color: @error;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          .van-icon{
            position: relative;
            top: 1px;
            width: 12px;
            height: 12px;
            background: @error;
            color: #FFF;
            border-radius: 50%;
            margin-right: 4px;
          }
        }
      }
    }
    .script-top-control{
      position: relative;
      z-index: 10;
      width: 100%;
      height: 52px;
      background: #FFF;
      box-shadow: 0px 2px 6px 0px rgba(199,163,97,0.06);
      display: flex;
      justify-content: space-between;
      align-items: center;
      .top-item{
        flex: 1;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: @black;
        height: 100%;
        &:not(:first-child)::after{
          content: '';
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
          width: 1px;
          height: 25px;
          background: #EEE;
        }
        svg{
          font-size: 28px;
          margin-right: 8px;
        }
      }
    }
    .herbs-list{
      overflow-y: scroll;
      width: 100%;
      flex: 1;
      -webkit-overflow-scrolling: touch;
      -webkit-overscroll-behavior: contain;
      padding: 12px 0;
      .script-title-editor{
        margin-bottom: 12px;
        height: 56px;
        width: 100%;
        background: #FFF;
        border: 1px solid #E7EDF3;
        border-left: 0;
        border-right: 0;
        padding: 0 24px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .title-type{
          position: relative;
          top: 2px;
          font-size: 15px;
          color: @black;
          line-height: 20px;
        }
        .title-typer{
          position: relative;
          top: 2px;
          flex: 1;
          padding-left: 20px;
          line-height: 30px;
          display: flex;
          align-items: center;
          input{
            padding: 0;
            line-height: 30px;
            width: 100%;
            font-size: 15px;
            font-weight:bold;
          }
        }
      }
      .list-wrapper{
        overflow: hidden;
      }
      .herb-item{
        float: left;
        position: relative;
        margin-bottom: 2px;
        background: #FFF;
        width: 50%;
        height: 52px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 16px 0 8px;
        overflow: hidden;
        &:nth-child(2n)::after{
          content: '';
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
          width: 1px;
          height: 28px;
          background: #EEE;
        }
        .medicine-control{
          width: 26px;
          height: 52px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-shrink: 0;
          .delete-icon{
            position: relative;
            width: 18px;
            height: 18px;
            border: 1px solid #CCC;
            border-radius: 50%;
            background: #FFF;
            &::after{
              content: '';
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 10px;
              height: 2px;
              border-radius: 1px;
              background: #999;
            }
          }
        }
        .medicine-info{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          font-size: 16px;
          font-weight: bold;
          color: @black;
          line-height: 20px;
          overflow: hidden;
          .medicine-name{
            padding-left: 4px;
            width: 68px;
            height: 100%;
            position: relative;
            // &::after{
            //   content: '';
            //   position: absolute;
            //   right: 0;
            //   top: 50%;
            //   transform: translateY(-50%);
            //   width: 1px;
            //   height: 20px;
            //   background: #EEE;
            // }
            .name{
              font-size: 15px;
              line-height: 20px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .special-method{
              font-size: 12px;
              line-height: 18px;
              color: #999;
              font-weight: normal;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
          .dose{
            padding-left: 12px;
            color: #666;
            display: flex;
            justify-content: flex-start;
            align-items: baseline;
            font-weight: normal;
            .dose-input{
              width: 50px;
              text-align: right;
              padding: 0 4px;
              color: @black;
              &.zero{
                color: @error;
              }
            }
            span{
              color: #666;
              font-weight: normal;
              margin-right: 4px;
            }
          }
        }
        // .medicine-control{
        //   line-height: 52px;
        //   font-size: 14px;
        //   color: #999;
        //   height: 100%;
        //   padding-left: 20px;
        //   white-space: nowrap;
        // }
      }
    }
    .script-bottom-control{
      position: relative;
      z-index: 10;
      width: 100%;
      background: #FFF;
      box-shadow: 0px 2px 6px 0px rgba(199,163,97,0.06);
      .search-results{
        width: 100%;
        height: 64px;
        overflow-x: scroll;
        white-space: nowrap;
        -webkit-overflow-scrolling: touch;
        padding: 0 24px;
        .result-item{
          display: inline-flex;
          margin-right: 28px;
          height: 100%;
          &.script{
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
          }
          &.herb{
            align-items: center;
            vertical-align: top;
            font-size: 16px;
            font-weight: bold;
            color: @black;
          }
          .script-name{
            font-size: 16px;
            line-height: 22px;
            color: @black;
            font-weight: bold;
            span{
              position: relative;
              top: -2px;
              display: inline-block;
              margin-left: 6px;
              height: 16px;
              padding: 0 4px;
              font-size: 12px;
              line-height: 16px;
              font-weight: normal;
              color: #999;
              border: 1px solid #999;
            }
          }
          .script-herbs{
            margin-top: 1px;
            font-size: 12px;
            line-height: 17px;
            color: #999;
          }
        }
        .empty-result{
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 13px;
          color: #999;
        }
        .searching{
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 13px;
          color: #666;
        }
      }
      .add-herb-typer{
        position: relative;
        padding: 12px 16px;
        box-shadow: 0px -2px 6px 0px rgba(199,163,97,0.06);
        z-index: 10;
        .herb-search-input{
          width: 100%;
          background: #F3F3F3;
          height: 40px;
          overflow: hidden;
          padding: 0 20px;
          font-size: 16px;
          line-height: 22px;
          border-radius: 4px;
        }
      }
      .herb-unit-editor{
        position: relative;
        padding: 12px 16px;
        box-shadow: 0px -2px 6px 0px rgba(54,104,166,0.05);
        z-index: 10;
        .editor-wrapper{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          height: 40px;
          padding: 6px 8px 6px 20px;
          background: #F3F3F3;
          border-radius: 4px;
          .herb-info{
            white-space: nowrap;
            display: flex;
            justify-content: flex-start;
            font-size: 15px;
            line-height: 20px;
            color: @black;
            flex-shrink: 0;
            span{
              max-width: 60px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              margin-right: 4px;
            }
          }
          .input-box{
            flex: 1;
            .unit-input{
              width: 100%;
              background: #F3F3F3;
              padding-left: 12px;
              line-height: 20px;
            }
          }
          .unit-edit-button{
            @button-base();
            flex-shrink: 0;
            width: 56px;
            height: 28px;
            font-weight: normal;
          }
        }
      }
    }
    .clear-content{
      padding: 40px 0 32px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .text{
        text-align: center;
        font-size: 16px;
        line-height: 16px;
        font-weight: bold;
        color: @black;
      }
      .control{
        margin-top: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        button{
          @button-base();
          height: 36px;
          font-size: 14px;
          width: 136px;
          &.cancel{
            background: #FFF;
            border: 1px solid #999;
            color: #999;
            margin-right: 15px;
          }
          &.confirm{}
        }
      }
    }
    // 特殊煎服法
    .special-list{
      height: 100%;
      background: #FAFAFA;
      overflow-y: auto;
      -webkit-overflow-scroll: touch;
      .special-item{
        width: 100%;
        height: 44px;
        line-height: 44px;
        font-size: 16px;
        color: @black;
        border-bottom: 1px solid #F3F3F3;
        text-align: center;
        &.selected{
          color: @xile;
        }
      }
    }
    // 自定义特殊煎服法
    .customize-content{
      padding: 20px 0 24px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .customize-text{
        width: 250px;
        .customize-input{
          width: 100%;
          height: 40px;
          font-size: 16px;
          color: @black;
          padding: 0 12px;
          background: #F7F7F7;
          border-radius: 4px;
        }
      }
      .customize-control{
        margin-top: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        button{
          @button-base();
          height: 36px;
          font-size: 14px;
          width: 119px;
          &.cancel{
            background: #FFF;
            border: 1px solid #999;
            color: #999;
            margin-right: 15px;
          }
          &.confirm{}
        }
      }
    }
  }
  .del-script-box{
    padding: 40px 0 32px;
    text-align: center;
    .warning{
      font-size: 16px;
      line-height: 16px;
      margin-bottom: 8px;
      color: @black;
    }
    p{
      font-size: 16px;
      line-height: 16px;
      color: @xile;
      font-weight: bold;
    }
    .tips{
      margin-top: 16px;
      font-size: 14px;
      line-height: 14px;
      color: #666;
    }
    .del-control{
      margin-top: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      button{
        @button-base();
        height: 36px;
        font-size: 14px;
        width: 136px;
        &.cancel{
          background: #FFF;
          border: 1px solid #999;
          color: #999;
          margin-right: 15px;
        }
        &.confirm{}
      }
    }
  }
  // iPhone5适配
  @media screen and (device-width: 320px) and (-webkit-device-pixel-ratio: 2){
    .edit-script-wrapper .herbs-list .herb-item{
      padding: 0 8px 0 4px;
    }
    .edit-script-wrapper .herbs-list .herb-item .medicine-info .medicine-name{
      width: 55px;
    }
    .edit-script-wrapper .herbs-list .herb-item .medicine-info .dose .dose-input{
      width: 40px;
      padding: 0;
    }
  }
</style>

<script type="text/javascript">
  import numberInput from '@/components/Common/numberInput'
  import xDialog from '@/components/Common/dialog'
  export default {
    data() {
      return {
        dataDone: false,
        // 是否为编辑模板
        isEdit: this.$route.query.type == 'edit' ? true : false,
        pageTitle: this.$route.query.id ? '编辑模板' : '新增模板',
        editId: this.$route.query.id || 0,
        scriptTitle: '',
        herbList: [],
        // 搜索框显示
        searchShow: true,
        // 药品剂量输入显示
        herbDoseEditShow: false,
        // 搜索关键字
        herbKey: '',
        // 显示搜索结果
        searchResultShow: false,
        // 是否搜索完成
        searchDone: false,
        // 搜索结果
        searchResult: [],
        // 选中的药材
        pickedHerb: {
          name: '未知',
          unit: 'g',
          num: null,
        },
        // 函数防抖
        timer: null,
        // 选择的特殊煎服法
        specialIndex: null,
        pickedSpecial: '',
        specialListShow: false,
        specialData: ['无', '先煎', '后下', '烊化', '包煎', '冲服', '单包', '打碎', '焗服', '另煎（炖）', '自定义'],
        // 自定义特殊煎服法
        customizeSpecialShow: false,
        customizeSpecial: '',
        // 清空药材弹窗
        clearHerbsShow: false,
        // 删除处方模板
        delScriptShow: false,
        deleteing: false,
        drug_typeEditShow:true,
        drug_type: 0,
        drugsError: false,
        drugsErrorMsg: '请选择药材类型',
        drugsData: [{
            label: '中药饮片',
            value: 1
          },
          {
            label: '配方颗粒',
            value: 2
          },
        ],
        drugsPickerShow: false,
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
    },
    components: {
      numberInput,
      xDialog
    },
    created() {
      if(this.$route.query.type == 'edit' && this.$route.query.id) {
        // 如果是编辑已有处方模板则获取处方模板
        this.$root.post('/getPreTmpDetail', {
          id: this.editId
        }).then(data => {
          console.log(data)
          if(data.drug_type>0){
            this.drug_type=data.drug_type;
            this.drug_typeEditShow=false;
          }

          this.dataDone = true;
          this.scriptTitle = data.title;
          this.herbList = data.content;
        })
      }else if(this.$route.query.type == 'classical' && this.$route.query.id) {
        // 如果是经方则获取经方的数据
        this.$root.post('/getClassicalPretDetail', {
          id: this.editId
        }).then(data => {
          this.dataDone = true;
          this.scriptTitle = data.title;
          if(data.content && data.content.length > 0) {
            data.content.forEach(herb => {
              herb.unit = 'g'
            })
          }
          this.herbList = data.content;
          console.log(this.herbList);
        })
      }else {
        this.dataDone = true;
      }
    },
    mounted() {
      document.body.className = 'full-height';
    },
    beforeDestroy() {
      document.body.className = '';
    },
    methods: {
      confirmDrugs(value) {
        this.drug_type = value.value;
        console.log(this.drug_type)
        this.drugsPickerShow = false;
      },
      searchBlur($event) {
        setTimeout(() => {
          this.searchResultShow = false;
          this.searchResult = [];
          this.herbKey = '';
        }, 50);
      },
      searchHerbs($event) {
        if(this.timer) clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          if(this.herbKey != ''&&parseInt(this.drug_type)>0 ) {
            this.searchDone = false;
            this.searchResult = [];
            this.searchResultShow = true;
            this.$root.post('/getDrugName', {
              search: this.herbKey,
              company_name: this.drug_type,
            }).then(data => {
              this.searchDone = true;
              this.searchResult = data || [];
            })
          }else{
             this.$notify('请选择处方类型');
          }
          this.timer = null;
        }, 500)
      },
      isListedHerb(herb) {
        let index = this.herbList.findIndex(item => {
          return item.name == herb.name;
        })
        if(index != -1) {
          return true;
        }else {
          return false;
        }
      },
      pickHerbItem(item) {
        if(parseInt(item.type) == 3) {
          // 添加单味药材
          let herbData = {
            name: item.title,
            unit: 'g',
            num: 0,
            remark: '',
          }
          if(this.isListedHerb(herbData)) {
            this.$notify('同一处方内禁止添加重复药材');
            return;
          }else {
            this.herbList.push(herbData);
            this.pickedHerb = {
              name: item.title,
              unit: item.unit,
              num: 0
            }
            this.$nextTick(() => {
              this.$refs.herbsList.scrollTop = this.$refs.herbsList.scrollHeight + this.$refs.herbsList.clientHeight;
            })

          }
          this.herbDoseEditShow = true;
          this.searchShow = false;
          this.$nextTick(() => {
            this.$refs.herbUnitInput.focus();
          })
        }else {
          // 添加模板&经方
          this.addScript(item.id, item.type, () => {
            this.$nextTick(() => {
              this.$refs.herbsList.scrollTop = this.$refs.herbsList.scrollHeight + this.$refs.herbsList.clientHeight;
            })
          });
        }
      },
      // 确认药品剂量
      comfirmUnit() {
        this.herbList[this.herbList.length - 1].num = this.pickedHerb.num;
      },
      numberBlur() {
        setTimeout(() => {
          this.searchShow = true;
          this.herbDoseEditShow = false;
        }, 50);
      },
      // 添加模板&经方&历史处方
      addScript(id, type, callBack, scriptType = this.scriptType) {
        this.$toast.loading({
          duration: 0,
          forbidClick: true,
          loadingType: 'spinner',
          message: '处方加载中'
        })
        this.$root.post('/getDrugList', {
          id: id,
          type: type,
          company_name: this.scriptType,
        }).then(data => {
          this.$toast.clear();
          if(data && data.length > 0) {
            data.forEach(herb => {
              let herbData = {
                name: herb.name,
                unit: herb.unit,
                num: parseFloat(herb.num),
                remark: herb.remark || '',
              }
              if(!this.isListedHerb(herbData)) {
                this.herbList.push(herbData);
              }
            })
          }
          callBack && callBack();
        })
      },
      pickSpecial(item, index) {
        this.specialIndex = index;
        this.specialListShow = true;
        this.pickedSpecial = item.remark;
      },
      chooseSpecial(item) {
        this.specialListShow = false;
        if(item == '无') {
          this.herbList[this.specialIndex].remark = '';
          this.specialIndex = null;
          this.pickedSpecial = '';
        }else if(item == '自定义') {
          this.customizeSpecialShow = true;
          this.$nextTick(() => {
            this.$refs.customizeInput.focus();
          })
        }else {
          this.herbList[this.specialIndex].remark = item;
          this.specialIndex = null;
          this.pickedSpecial = '';
        }
      },
      saveCustomizeSpecial() {
        if(!this.customizeSpecial) {
          this.$notify('请输入自定义的特殊煎服法');
          return;
        }
        this.herbList[this.specialIndex].remark = this.customizeSpecial;
        this.customizeSpecialShow = false;
      },
      // 删除单味药材
      delMedicine(item) {
        // 清空保存的特殊煎服法index
        this.specialIndex = null;
        let index = this.herbList.findIndex(herb => {
          return item.name == herb.name;
        })
        if(index != -1) {
          this.herbList.splice(index, 1);
        }
      },
      // 清空药材
      clearHerbs() {
        this.herbList = [];
        this.clearHerbsShow = false;
      },
      // 保存
      savePrescription() {
        if(!this.drug_type){
          this.$notify('请选择处方类型');
          return;
        }
        if(!this.scriptTitle) {
          this.$notify('请输入处方名称');
          return;
        }
        if(this.herbList.length <= 0) {
          this.$notify('请至少添加一味药材');
          return;
        }
        let emptyNumber = false;
        this.herbList.forEach(item => {
          if(item.num <= 0) {
            emptyNumber = true;
            return false;
          }
        })
        if(emptyNumber) {
          this.$notify('药材剂量不能为0');
          return;
        }

        this.$toast.loading({
          duration: 0,
          forbidClick: true,
          loadingType: 'spinner',
          message: '保存中'
        })
        console.log(this.herbList)
        this.$root.post('/addPreTmp', {
          title: this.scriptTitle,
          doc_id: this.userInfo.user_id,
          content: this.herbList,
          id: this.isEdit ? this.editId : 0,
          drug_type:this.drug_type,
          company_name:this.drug_type
        }).then(data => {
          this.$toast.clear();
          if(data.status == 1) {
            let message = this.editId && this.isEdit ? '编辑处方模板成功' : '添加处方模板成功';
            this.$notify({
              background: '#00848A',
              message: message
            });
            this.$router.go(-1);
          }else {
            this.$notify(data.msg);
          }
        })
      },
      // 删除处方
      delScript() {
        this.delScriptShow = true;
      },
      delScriptAction() {
        this.deleteing = true;
        this.$root.post('/delPreTmp', {
          id: this.editId
        }).then(data => {
          this.deleteing = false;
          if(data.status == 1) {
            this.$notify({
              background: '#00848A',
              message: '处方模板删除成功'
            });
            this.$router.go(-1);
          }else {
            this.$notify(data.msg);
          }
        })
      },
    },
    filters: {

      formulationTypeFilter(type) {
        switch (type) {
          case 1:
            return '中药饮片';
            break;
          case 2:
            return '配方颗粒';
            break;
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/Prescription/edit.vue